module.exports = __webpack_public_path__ + "img/logo.f7e5f7fd.png";